import VehicleModel from 'commons-vehicle/Vehicle/models/VehicleModel.js';
import VehicleModelV25 from 'commons-vehicle/Vehicle/models/VehicleModelV25.js';

import TradeInVehicleModel from 'commons-vehicle/Vehicle/models/TradeInVehicleModel.js';
import MultiMediaModel from 'commons-vehicle/Vehicle/models/MultiMediaModel.js';
import InventoryMultimediaModelV25 from 'commons-vehicle/Vehicle/models/InventoryMultimediaModelV25.js';
import InventoryAccessoriesAndOptionModelV25 from 'commons-vehicle/Vehicle/models/InventoryAccessoriesAndOptionModelV25.js';
import PaymentOptionsModel from 'commons-vehicle/Vehicle/models/PaymentOptionsModel.js';

import VehicleActions from 'commons-vehicle/Vehicle/actions/vehicleActions.js';
import VehicleActionTypes from 'commons-vehicle/Vehicle/actions/vehicleActionTypes.js';
import TradeInValue from 'commons-vehicle/Vehicle/components/PaymentOptionFilters/TradeInValue/TradeInValue.jsx';
import TradeInVehicleActions from 'commons-vehicle/Vehicle/actions/tradeInVehicleActions.js';
import TradeInVehicleActionTypes from 'commons-vehicle/Vehicle/actions/tradeInVehicleActionTypes.js';

import VehicleReducer from 'commons-vehicle/Vehicle/reducers/vehicleReducer.js';
import VehicleReducerV25 from 'commons-vehicle/Vehicle/reducers/vehicleReducerV25.js';
import TradeInVehicleReducer from 'commons-vehicle/Vehicle/reducers/tradeInVehicleReducer.js';

import VehicleService from 'commons-vehicle/Vehicle/services/VehicleService/VehicleService.js';
import VehicleAPIService from 'commons-vehicle/Vehicle/services/VehicleAPIService/VehicleAPIService.js';
import TradeInVehicleService from 'commons-vehicle/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js';
import TradeInVehicleServiceV25 from 'commons-vehicle/Vehicle/services/TradeInVehicleServiceV25/TradeInVehicleServiceV25.js';
import TradeInVehicleAPIService from 'commons-vehicle/Vehicle/services/TradeInVehicleAPIService/TradeInVehicleAPIService.js';

import CertificationIconService from 'commons-vehicle/Vehicle/services/CertificationIconService/CertificationIconService.js';

import BADGE_STATUS from 'commons-vehicle/Vehicle/constants/badgeStatus.js';
import TRADEIN_STATUSES from 'commons-vehicle/Vehicle/constants/tradeInVehicleStatuses.js';
import URL from 'commons-vehicle/Vehicle/constants/url.js';

import Payment from 'commons-vehicle/Vehicle/components/Payment/Financing/Financing.jsx';
import CashPayment from 'commons-vehicle/Vehicle/components/Payment/CashPayment/CashPayment.jsx';
import PaymentDetail from 'commons-vehicle/Vehicle/components/Payment/PaymentDetail/PaymentDetail.jsx';
import Price from 'commons-vehicle/Vehicle/components/Payment/Price/Price.jsx';

import PaymentV2 from 'commons-vehicle/Vehicle/components/PaymentV2/Financing/Financing.jsx';
import CashPaymentV2 from 'commons-vehicle/Vehicle/components/PaymentV2/CashPayment/CashPayment.jsx';
import PaymentDetailV2 from 'commons-vehicle/Vehicle/components/PaymentV2/PaymentDetail/PaymentDetail.jsx';
import PriceV2 from 'commons-vehicle/Vehicle/components/PaymentV2/Price/Price.jsx';

import Overview from 'commons-vehicle/Vehicle/components/Overview/Overview.jsx';
import VehicleSummary from 'commons-vehicle/Vehicle/components/Overview/VehicleSummary/VehicleSummary.jsx';
import AppointmentCTA from 'commons-vehicle/Vehicle/components/CallToAction/Appointment/AppointmentCTA.jsx';
import BuyOnlineCTA from 'commons-vehicle/Vehicle/components/CallToAction/BuyOnline/BuyOnlineCTA.jsx';
import BuyOnlineCTAV25 from 'commons-vehicle/Vehicle/components/CallToAction/BuyOnline/BuyOnlineCTAV25.jsx';
import ExtraCTAV25 from 'commons-vehicle/Vehicle/components/CallToAction/ExtraCta/ExtraCTAV25.jsx';
import AppointmentCTAV25 from 'commons-vehicle/Vehicle/components/CallToAction/Appointment/AppointmentCTAV25.jsx';
import PriceQuoteCTA from 'commons-vehicle/Vehicle/components/CallToAction/PriceQuote/PriceQuoteCTA.jsx';
import PriceQuoteCTAV25 from 'commons-vehicle/Vehicle/components/CallToAction/PriceQuote/PriceQuoteCTAV25.jsx';
import ViewAllInventoryCTA from 'commons-vehicle/Vehicle/components/CallToAction/ViewAllInventory/ViewAllInventoryCTA.jsx';
import MotoInsightCTA from 'commons-vehicle/Vehicle/components/CallToAction/ThirdParties/MotoInsight/MotoInsightCTA.jsx';
import RoadsterCTA from 'commons-vehicle/Vehicle/components/CallToAction/ThirdParties/Roadster/RoadsterCTA.jsx';
import EshopCTA from 'commons-vehicle/Vehicle/components/CallToAction/ThirdParties/Eshop/EshopCTA.jsx';
import ShopClickDriveCTA from 'commons-vehicle/Vehicle/components/CallToAction/ThirdParties/ShopClickDrive/ShopClickDriveCTA.jsx';
import ThirdPartiesCTA from 'commons-vehicle/Vehicle/components/CallToAction/ThirdParties/ThirdPartiesCTA.jsx';
import PaymentOptionFilters from 'commons-vehicle/Vehicle/components/PaymentOptionFilters/PaymentOptionFilters.jsx';
import VehicleBannerWithCarrousel from 'commons-vehicle/Vehicle/components/VehicleBannerWithCarrousel/VehicleBanner/VehicleBanner.jsx';
import VehicleRebate from 'commons-vehicle/Vehicle/components/VehicleRebate/VehicleRebate.jsx';
import LightboxCarrousel from 'commons-vehicle/Vehicle/components/LightboxCarrousel/LightboxCarrousel.jsx';
import VehicleDisclaimersContent from 'commons-vehicle/Vehicle/components/VehicleDisclaimersContent/VehicleDisclaimersContent.jsx';
import VehicleTitleSpecs from 'commons-vehicle/Vehicle/components/VehicleTitleSpecs/VehicleTitleSpecs.jsx';
import VehicleBannerOverlay from 'commons-vehicle/Vehicle/components/VehicleBannerWithCarrousel/VehicleBanner/VehicleBannerOverlay/VehicleBannerOverlay.jsx';
import TradeInOfficialValue from 'commons-vehicle/Vehicle/components/TradeInOfficialValue/TradeInOfficialValue.jsx';
import CompareButton from 'commons-vehicle/Vehicle/components/CompareButton/CompareButton.jsx';

import TileTag from 'commons-vehicle/Vehicle/components/TileTag/TileTag.jsx';

import en from 'commons-vehicle/Vehicle/i18n/en.json';
import fr from 'commons-vehicle/Vehicle/i18n/fr.json';

const Translation = { en, fr };

export {
    VehicleActions,
    VehicleActionTypes,
    TradeInVehicleActions,
    TradeInVehicleActionTypes,
    Payment,
    CashPayment,
    Price,
    PaymentDetail,
    PaymentV2,
    CashPaymentV2,
    PriceV2,
    PaymentDetailV2,
    Overview,
    VehicleSummary,
    Translation,
    VehicleModel,
    VehicleModelV25,
    InventoryAccessoriesAndOptionModelV25,
    VehicleReducer,
    VehicleReducerV25,
    VehicleService,
    VehicleAPIService,
    MultiMediaModel,
    InventoryMultimediaModelV25,
    TradeInValue,
    TradeInVehicleModel,
    TradeInVehicleReducer,
    TradeInVehicleService,
    TradeInVehicleServiceV25,
    TradeInVehicleAPIService,
    CertificationIconService,
    BADGE_STATUS,
    TRADEIN_STATUSES,
    URL,
    AppointmentCTA,
    BuyOnlineCTA,
    BuyOnlineCTAV25,
    AppointmentCTAV25,
    ExtraCTAV25,
    PriceQuoteCTA,
    PriceQuoteCTAV25,
    PaymentOptionsModel,
    PaymentOptionFilters,
    VehicleBannerWithCarrousel,
    VehicleRebate,
    LightboxCarrousel,
    VehicleDisclaimersContent,
    VehicleTitleSpecs,
    TileTag,
    VehicleBannerOverlay,
    TradeInOfficialValue,
    ViewAllInventoryCTA,
    MotoInsightCTA,
    RoadsterCTA,
    EshopCTA,
    ShopClickDriveCTA,
    ThirdPartiesCTA,
    CompareButton,
};

export default {
    VehicleActions,
    VehicleActionTypes,
    TradeInVehicleActions,
    TradeInVehicleActionTypes,
    BADGE_STATUS,
    URL,
    Payment,
    CashPayment,
    Price,
    PaymentDetail,
    PaymentV2,
    CashPaymentV2,
    PriceV2,
    PaymentDetailV2,
    Overview,
    VehicleSummary,
    Translation,
    VehicleModel,
    VehicleModelV25,
    InventoryAccessoriesAndOptionModelV25,
    VehicleReducer,
    VehicleReducerV25,
    VehicleService,
    VehicleAPIService,
    MultiMediaModel,
    InventoryMultimediaModelV25,
    CertificationIconService,
    TradeInValue,
    TradeInVehicleModel,
    TradeInVehicleReducer,
    TradeInVehicleService,
    TradeInVehicleServiceV25,
    TradeInVehicleAPIService,
    TRADEIN_STATUSES,

    AppointmentCTA,
    BuyOnlineCTA,
    BuyOnlineCTAV25,
    AppointmentCTAV25,
    ExtraCTAV25,
    PriceQuoteCTA,
    PriceQuoteCTAV25,
    PaymentOptionsModel,
    PaymentOptionFilters,
    VehicleBannerWithCarrousel,
    VehicleRebate,
    LightboxCarrousel,
    VehicleDisclaimersContent,
    VehicleTitleSpecs,
    TileTag,
    VehicleBannerOverlay,
    TradeInOfficialValue,
    ViewAllInventoryCTA,
    MotoInsightCTA,
    RoadsterCTA,
    EshopCTA,
    ShopClickDriveCTA,
    ThirdPartiesCTA,
    CompareButton,
};
